import { CheckCircle2, Circle } from "lucide-react";

const STEPS = [
  { key: "business_idea", label: "Idea", module: 1 },
  { key: "team_roles", label: "Team", module: 2 },
  { key: "business_plan", label: "Plan", module: 3 },
  { key: "brand_marketing", label: "Brand", module: 4 },
  { key: "financial_plan", label: "Money", module: 5 },
  { key: "challenge_strategy", label: "Strategy", module: 6 },
  { key: "final_pitch", label: "Pitch", module: 7 },
];

export default function CapstoneTracker({ completedModules = [], capstoneFields = {} }) {
  return (
    <div className="bg-white rounded-2xl shadow-lg p-6 mb-8" data-testid="capstone-tracker">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold text-gray-800">Build Your Business</h2>
        <span className="text-sm text-gray-500">
          {STEPS.filter(s => completedModules.includes(s.module) || capstoneFields[s.key]).length}/{STEPS.length} complete
        </span>
      </div>
      <div className="flex items-center justify-between gap-1 overflow-x-auto pb-2">
        {STEPS.map((step, i) => {
          const done = completedModules.includes(step.module) || !!capstoneFields[step.key];
          return (
            <div key={step.key} className="flex items-center flex-1 min-w-0">
              <div className="flex flex-col items-center" data-testid={`capstone-step-${step.key}`}>
                {done ? (
                  <CheckCircle2 className="w-8 h-8 text-green-500 shrink-0" />
                ) : (
                  <Circle className="w-8 h-8 text-gray-300 shrink-0" />
                )}
                <span className={`text-xs font-medium mt-1 whitespace-nowrap ${done ? "text-green-700" : "text-gray-400"}`}>
                  {step.label}
                </span>
              </div>
              {i < STEPS.length - 1 && (
                <div className={`flex-1 h-0.5 mx-1 mt-[-12px] ${done ? "bg-green-400" : "bg-gray-200"}`} />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
